import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';
import React from 'react';

const NetworkStatusIndicator = (): JSX.Element | null => {
  const theme = useTheme();
  const [onLine, setOnLine] = React.useState(navigator.onLine);

  React.useEffect(() => {
    const onLineListener = () => setOnLine(true);
    const offLineListener = () => setOnLine(false);
    window.addEventListener('online', onLineListener);
    window.addEventListener('offline', offLineListener);

    return () => {
      window.removeEventListener('online', onLineListener);
      window.removeEventListener('offline', offLineListener);
    };
  });

  if (onLine) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.getContrastText(theme.palette.error.dark),
        fontSize: '1rem',
        padding: '.2em',
        textAlign: 'center',
        width: '100%',
        zIndex: theme.zIndex.snackbar,
      }}
    >
      {t('errors.offline')}
    </Box>
  );
};

export default NetworkStatusIndicator;
